export const setStorage = (key, value, concat) => {
    let v = localStorage.getItem(key) && JSON.parse(localStorage.getItem(key)),
        res
    if (concat && v && Array.isArray(v)) {
        if (!Array.isArray(value)) {
            value = [value]
        }
        res = localStorage.setItem(key, JSON.stringify(v.concat(value)))
    } else {
        res = localStorage.setItem(key, JSON.stringify(value))
    }
    return res
}
export const getStorage = key => {
    try {
        return JSON.parse(localStorage.getItem(key))
    } catch (error) {
        return null
    }
}
